/* ==========================================================================
   sk-atc-smart-flow.js — Smart ATC Routing
   --------------------------------------------------------------------------
   Intercepts ATC click BEFORE Empire's handler and routes:
   - Normal ATC (no video): POST /cart/add.js → open sk-drawer (right-side)
   - Video-Gate (product/cart has video): native submit + return_to=/cart
   - Buy-Now button + no video: native submit + return_to=/checkout
   ========================================================================== */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function productHasVideo(form) {
    if (!form) return false;
    var btn = form.querySelector('[data-product-atc]');
    if (btn && btn.getAttribute('data-sk-has-video') === 'true') return true;
    return form.getAttribute('data-sk-product-has-video') === 'true';
  }
  function cartHasVideo() {
    return !!(window.skCart && window.skCart.hasVideo === true);
  }

  function setReturnTo(form, path) {
    var existing = form.querySelector('input[name="return_to"]');
    if (existing) existing.remove();
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'return_to';
    input.value = path;
    form.appendChild(input);
  }

  function addToCartViaApi(form) {
    var body = new URLSearchParams();
    var formData = new FormData(form);
    formData.forEach(function (v, k) { body.append(k, v); });
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: body.toString(),
    }).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (txt) { throw new Error('Add failed: ' + res.status + ' ' + txt.slice(0, 100)); });
      }
      return res.json();
    });
  }

  function openSkDrawer() {
    if (window.skDrawer && typeof window.skDrawer.open === 'function') {
      window.skDrawer.open();
    } else {
      window.location.href = '/cart';
    }
  }

  function handleIntercept(e, submitter) {
    var form = submitter && submitter.closest('form');
    if (!form) return;
    if (!form.matches('form[data-product-form], form.product-form, form[action*="/cart/add"]')) return;
    var isBuyNow = submitter.hasAttribute('data-sk-buy-now');
    var isAtc = submitter.hasAttribute('data-product-atc') || submitter.classList.contains('product-form--atc-button');
    if (!isBuyNow && !isAtc) return;

    var willHaveVideo = productHasVideo(form) || cartHasVideo();

    // CASE A: Buy-Now + kein Video → direkt zu /checkout via native submit
    if (isBuyNow && !willHaveVideo) {
      setReturnTo(form, '/checkout');
      e.stopImmediatePropagation();
      if (e.type === 'click') {
        setTimeout(function () {
          if (form.requestSubmit) form.requestSubmit(submitter); else form.submit();
        }, 0);
      }
      return;
    }

    // CASE B: Normal ATC / Video / Buy-Now auf Video → /cart/add.js + sk-drawer
    //         Inline Video-Gate rendert client-side aus window.skVideoData.
    //         Reload nur wenn das Produkt Video-Pflicht hat ABER skVideoData die
    //         URL nicht kennt (z.B. ATC von Collection/Home ohne Produkt-Kontext).
    e.preventDefault();
    e.stopImmediatePropagation();

    submitter.classList.add('processing');
    submitter.setAttribute('disabled', 'disabled');

    var addedProductHasVideo = productHasVideo(form);

    addToCartViaApi(form)
      .then(function (addedItem) {
        submitter.classList.remove('processing');
        submitter.removeAttribute('disabled');

        // Reload-Fallback: Video-Produkt ohne client-side Video-Daten
        // → Page-Reload lädt skVideoData frisch via Liquid (inkl. neuem Cart-Item)
        if (addedProductHasVideo) {
          var pid = addedItem && addedItem.product_id ? String(addedItem.product_id) : null;
          var haveVideoData = pid && window.skVideoData && window.skVideoData[pid];
          if (!haveVideoData) {
            var url = window.location.pathname + window.location.search;
            url += (url.indexOf('?') === -1 ? '?' : '&') + 'sk_drawer_open=1';
            window.location.href = url;
            return;
          }
        }

        // Standard-Case: direkt drawer öffnen ohne reload (funktioniert auch für Video-Produkte,
        // wenn skVideoData die URL bereits kennt)
        openSkDrawer();
      })
      .catch(function (err) {
        console.error('[sk-atc] /cart/add.js failed', err);
        submitter.classList.remove('processing');
        submitter.removeAttribute('disabled');
        try {
          setReturnTo(form, '/cart');
          if (form.requestSubmit) form.requestSubmit(submitter); else form.submit();
        } catch (_) {}
      });
  }

  // Click handler — capture phase, runs BEFORE Empire
  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-product-atc], [data-sk-buy-now]');
    if (!target) return;
    handleIntercept(e, target);
  }, true);

  // Submit fallback
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches('form[data-product-form], form.product-form, form[action*="/cart/add"]')) return;
    var submitter = e.submitter || form.querySelector('[data-product-atc], [data-sk-buy-now]');
    if (!submitter) return;
    var willHaveVideo = productHasVideo(form) || cartHasVideo();
    var isBuyNow = submitter.hasAttribute('data-sk-buy-now');
    if (!isBuyNow && !willHaveVideo) {
      // For normal case, the submit event might fire even though we preventDefault on click.
      // Prevent it to avoid double-submission.
      e.preventDefault();
      return;
    }
  }, true);

  // UI state updates
  function updateUiState() {
    var hasVideo = cartHasVideo();
    document.querySelectorAll('[data-sk-hide-if-cart-has-video]').forEach(function (btn) {
      if (hasVideo) btn.classList.add('sk-buy-now-button--hidden');
      else btn.classList.remove('sk-buy-now-button--hidden');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateUiState);
  else updateUiState();
  window.addEventListener('sk:cart-changed', updateUiState);

  // Expose header cart icon click → open drawer
  document.addEventListener('click', function (e) {
    var trg = e.target.closest('.site-header-cart--button, [data-sk-open-drawer]');
    if (!trg) return;
    // Only intercept if we have a drawer and user's not ctrl/cmd-clicking
    if (!window.skDrawer || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    openSkDrawer();
  });
})();
